import { render, staticRenderFns } from "./VehicleTypeEditInfo.vue?vue&type=template&id=c235ee76&"
import script from "./VehicleTypeEditInfo.vue?vue&type=script&lang=js&"
export * from "./VehicleTypeEditInfo.vue?vue&type=script&lang=js&"
import style0 from "./VehicleTypeEditInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports